export const Bio = {
  name: "Emerson Marinho",
  roles: [
    "Desenvolvedor Full Stack",
  ],
  description:
      "Sou uma pessoa motivada e versátil, sempre ansiosa por enfrentar novos desafios. Com uma paixão por aprender, estou dedicado a entregar resultados de alta qualidade. Com uma atitude positiva e uma mentalidade de crescimento, estou pronto para fazer uma contribuição significativa e alcançar grandes coisas.",
  github: "https://github.com/EmersonMarinho",
  resume:
    "https://drive.google.com/file/d/1ug3VZG1sHNkd2RrAzJojyuNq47_LP5gN/view?usp=share_link",
  linkedin: "https://www.linkedin.com/in/emerson-marinho/",
};

export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "React Js",
        image:
         "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a7/React-icon.svg/1200px-React-icon.svg.png",
      },
      {
          name: "Next Js",
          image:
           "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAAe1BMVEX///8AAADV1dXh4eGjo6NZWVm+vr7Jycl9fX2NjY2Tk5Pe3t7v7+/39/f8/PzMzMzo6OhISEirq6uHh4fw8PB4eHizs7PFxcUvLy9DQ0M1NTVTU1Nvb28lJSVmZmYVFRWnp6dGRkYcHByZmZk8PDwXFxdhYWEpKSlYWFgsBK0WAAAE60lEQVR4nO2a2XLbOBBFScuLFkvWZsuxpcixPLL//wtHXNAgSCwkRKZqas55SFIgCOKKQPdFM0kCAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/21uFPNg19lNC5oDL13jjWajnJnqMW/zAOdwLlLFKth1lbbgUfU+SZNjTjvpoH6WhzYPmEYrTMehrnedFCZ71fRqHW0pt9yrpqc2DzjFK0xf+lWYvKq235bBFkd1dSNtgytMb/xduyqc+2YlS76yO4ZXmG57VZjcSOt9fayxunJc/FWFv/pVmLxI88gcyn5h6EiTsW+h8Pxx6+ZkJp1nNfBhUW2eyQONl7s8VYf6UDevjSc8XacwvQ0r7LRMvtTAd5VGvUG9L0Slky7Ps1BfBJ6f6C5imSxsYn6ptrP33vteFb5I8H50do1RmIxEoiQjWbqfC9+dPSt8kq3x5uwapVDmmaazomEtDQED1q/CB/1gW37OiVOYbNTAxzwK6RTyELixb4V68bhCSaRCM7l7bYBJ7wp13HP8uLEKdTS7GLS34FIR+leof177BolWWDHZATtu0L9CnYgP1iAXrbASbQR3yG7c1f15BsbCFDNlTVQxGb9kWhcYMPk5QyjUhnhi6VoqfJ9ObGxGlluEH1OgzzoJgyhM/siOaXYNOG+/YTxWu3rtrzCMQh33Zo2uVyl8rPT8aje1gRSKyzo2SlNXKawc/j7DRa+cgRTquPde73qdwkppyn/QbsykixwLDYXJRE1kU+t6pcLkt+rptr4GgylM3tVMaqWpgMKQzUySb9V1mEizGC1tedw2PYl7ZrQpFY6XMyve3fWc/aFNU2/Z4kGun3I/uGoWDG0KtcsyZh3vaS7ni1yiPle0qUW0UfhUXn/8R43cqDVZl9jO2j1eYeaV1tk/PkRii+J8F4X52r+dZNWD51oX+yYSl1XtHq2w8Lu5URPnbbe+Bh0UrtWWyu6pWV67wuSsZrLWbbEKVa0mTxJyRPPXaNRsWyrcS/RafaY7s4tDYfKpZqI9cqxCVXh6zV5byzpbRjeFzi9LLoVbmYm89EiFUjso4paule4CN3ZQmG30Z4eRcCnULkvyc5xCXXgqDx+63t1DJUpFmkPW8c/EdihzKkxu1URUfo5SaPl2ob9Z+A1qF4ULFcI2jTfpVqhdVpmfYxRat51Em4b1Neii8HJk2JSWqX4o8ijUHwCL/BxzxpfCUzV06kJ43foadFN4YVuUgWorw6dQv4A82pQKV2MPe3N4nf6MZl0Itxy04xUmRRyrWUKfQr2JDhWFfox0K1u5HlQahfDrFG6nJ7UJxo3P9V6FOhCeYxTqQ29jeCmE19dUS4WXgPxd/v1VLPvyEe+NGpNfoU5m0+4KdUq1bF05orm/ytoVzvev98Xqylb4d7GXs7J6nimyOF1z9QGFOlTsOiuU46C1vC1HtLpTDijMNCyKKLjKo32WHnIbcfzJvx/UzU1IoY57W/Gq7RRKsgn9b5O19bpP4WVlb5WtLN6YTrt39WHKdreD0i5L0lgrhZNmk4n+H0OOw6Jd4fZ8KALwx8/Fxeiv6i/ni+a3cdPVLAs87mI5KpmNwszkUHSjzv7O+r2+y3597r0KAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADwv+Vfynwx33WBCacAAAAASUVORK5CYII=",
        },
      {
        name: "Redux",
        image:
          "https://d33wubrfki0l68.cloudfront.net/0834d0215db51e91525a25acf97433051f280f2f/c30f5/img/redux.svg",
      },
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
          name: "Tailwind CSS",
          image:
            "https://logowik.com/content/uploads/images/tailwind-css3232.logowik.com.webp",
        },
    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "Node Js",
        image: "https://nodejs.org/static/images/logo.svg",
      },
      {
          name: "Typescript",
          image: "data:image/png;base64,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",
        },
        {
          name: "Nest JS",
          image:
            "https://docs.nestjs.com/assets/logo-small.svg",
        },
      {
        name: "Python",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
      },
      {
        name: "MySQL",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
      },
      {
        name: "Postgresql",
        image: "https://www.postgresql.org/media/img/about/press/elephant.png",
      },
      {
          name: "Java",
          image: "https://1000logos.net/wp-content/uploads/2020/09/Java-Logo.png",
        },
    ],
  },
  {
    title: "Outros",
    skills: [
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
      {
        name: "Docker",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/docker/docker-original-wordmark.svg",
      },
      {
        name: "VS Code",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
      },
      {
        name: "Insonmia",
        image:
          "https://seeklogo.com/images/I/insomnia-logo-A35E09EB19-seeklogo.com.png",
      },
      {
          name: "Jest",
          image:
            "data:image/png;base64,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",
        },
    ],
  },
];

export const experiences = [
  {
    id: 0,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSO_bVwP2vQqtt0C_-z-napj3sby1f9pbnA9A&s",
    role: "Forensic Assistant",
    company: "Ernst & Young",
    date: "MAI 2019 - OUT 2019",
    desc: "Fui Assistente em Forensic onde pude atuar em projetos de Compliance como: Investigação de Fraudes de pessoas e Empresas, Mapeamento de Targets, Ajudar na construção de relatório Anti-Fraude de Due-Diligence e Background Check, entre outros projetos.",
    skills: [
      "Comunicação",
      "Excel",
      "Trabalho em Equipe"
    ],
    doc: "",
  },
  {
    id: 0,
    img: "https://w7.pngwing.com/pngs/136/726/png-transparent-kpmg-hd-logo.png",
    role: "Trainee",
    company: "KPMG",
    date: "JAN 2021 - JUL 2021",
    desc: "Auxiliar na apuração e revisão de tributos diretos e/ou indiretos. Preparação de obrigações acessórias (SPED). Análise e aplicação da legislação tributária, Compliance de tributos diretos e/ou indiretos.",
    skills: [
      "Comunicação",
      "Excel",
      "Trabalho em Equipe",
      "Resolucão de Problemas",
      "Adaptabilidade"
    ],
    doc: "",
  }
];

export const education = [
  {
    id: 0,
    img: "https://clube-static.clubegazetadopovo.com.br/parceiros/611580237461067.png",
    school: "ESIC Business & Marketing School",
    date: "JUL 2018 - JUL 2022",
    desc: "No curso de bacharelado em Negócios Internacionais da ESIC, o aluno terá conhecimentos de comércio exterior, bem como das áreas de marketing, produção, logística ou finanças de empresas internacionalizadas e que atuarão em um mundo em constante transformação. Desenvolverá habilidades com relação aos conhecimentos de comércio exterior e negócios internacionais, assim como de sua legislação específica e habilidades na construção de um Plano de Negócios Internacionais.",
    degree: "Bacharelado, Negócios Internacionais",
  },
  {
    id: 0,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQgJLI_k1KcBWDs2fPzyjeQLmnH8IFDygJKuw&s",
    school: "Trybe",
    date: "NOV 2022 - NOV 2023",
    desc: "A formação da Trybe consiste em ensinar a programar, a aprender e a trabalhar. Além de habilidades técnicas de programação, aborda o desenvolvimento de soft skills (habilidades socioemocionais), e a preparação para processos seletivos.",
    degree: "Curso Livre, Desenvolvedor Full-Stack",
  }
];

export const projects = [
  {
    id: 9,
    title: "Find a Friend",
    description:
      "FindAFriend é uma plataforma online destinada a conectar ONGs que abrigam pets a pessoas interessadas em adotar um animal de estimação. O principal objetivo é facilitar o processo de adoção, permitindo que os usuários encontrem o pet ideal de acordo com suas preferências e localização, enquanto oferece às ONGs uma maneira eficaz de apresentar os animais que necessitam de um lar.",
    image:
      "https://i.imgur.com/r5B5VCM.png",
    tags: [
      "Docker",
      "Node Js",
      "Sequelize",
      "Postgres",
      "React Js",
      "Express Js",
      "Context API",
      "Tailwind CSS"
    ],
    category: "web app",
    github: "",
    webapp: "",
  },
  {
    id: 9,
    title: "Code Type",
    description:
      "CodeType é uma aplicação web moderna focada em ajudar desenvolvedores a melhorarem sua velocidade e precisão na digitação de código. Com uma interface elegante e feedback em tempo real, o CodeType oferece uma experiência única de aprendizado.",
    image:
      "https://i.imgur.com/0I3xYCK.png",
    tags: [
      "Node Js",
      "Postgres",
      "React Js",
      "Express Js",
      "Context API",
      "Tailwind CSS"
    ],
    category: "web app",
    github: "https://github.com/EmersonMarinho/CodeType?tab=readme-ov-file",
    webapp: "https://code-type-henna.vercel.app/",
  },  
  {
    id: 9,
    title: "Gerador de Dossiês",
    description:
      "Uma aplicação que gera automaticamente dossiês empresariais a partir de números de CNPJ. O sistema realiza consultas a APIs para compilar relatórios detalhados contendo informações da empresa.",
    image:
      "https://i.imgur.com/ZR2DGU7.png",
    tags: [
      "Node Js",
      "Sequelize",
      "Postgres",
      "React Js",
      "Express Js",
      "Context API",
      "Tailwind CSS"
    ],
    category: "web app",
    github: "https://github.com/EmersonMarinho/GeradorDeDossieEmpresarial",
    webapp: "https://gerador-de-dossie-empresarial-9ug3ovn59.vercel.app/",
  },
  {
    id: 10,
    title: "Fintra",
    description:
      "Fintra é um sistema financeiro completo que transforma a gestão financeira com relatórios inteligentes, automação de processos e insights que impulsionam o crescimento. A plataforma oferece gestão de contas bancárias e cartões, categorização de receitas e despesas, controle de transações, criação de orçamentos, definição e acompanhamento de metas financeiras, além de gamificação para tornar a rotina financeira mais envolvente e motivadora.",
    image:
      "https://i.imgur.com/pIdpHRh.png",
    tags: [
      "React Js",
      "Node Js",
      "Postgres",
      "Express Js",
      "TypeScript",
      "Tailwind CSS"
    ],
    category: "web app",
    github: "",
    webapp: "https://www.fintrabr.com/",
  },
];

export const TimeLineData = [
  { year: 2022, text: "Started my journey" },
];